<template>
  <div class="common-button-container">
    <button
      @click="(e) => $emit('click', e)"
      :class="componentClass"
      :type="type"
      :disabled="disabled"
    >
      <slot />
    </button>
  </div>
</template>

<script>
const MEDIUM_SIZE = 'medium';
const PRIMARY_SIGNIFICANCE = 'primary';
const SECONDARY_SIGNIFICANCE = 'secondary';

const significanceMatcher = (props) => {
  const { primary, secondary } = props;

  if (primary) {
    return PRIMARY_SIGNIFICANCE;
  }

  if (secondary) {
    return SECONDARY_SIGNIFICANCE;
  }

  return '';
};

export default {
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
      validator: function(value) {
        const validTypes = ['reset', 'button', 'submit'];
        return validTypes.find((item) => item === value);
      },
    },
  },
  computed: {
    componentClass() {
      const significance = significanceMatcher(this) || SECONDARY_SIGNIFICANCE;
      const size = MEDIUM_SIZE;
      return [significance, size].join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
.common-button-container {
  display: inline-block;
}

button {
  transition: background 166ms cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  border: none;
  border-radius: 3px;
  color: var(--ink-clear);
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(24, 33, 35, 0.16);
  font-weight: 600;
}

button.primary {
  background-color: var(--primary-base);
  border-radius: 20px;
}

button.medium {
  min-width: 100px;
  height: 40px;
}

button.secondary {
  color: var(--ink-base);
  background-color: var(--surface-base);
  border: solid 1px var(--neutral-dark);
  -webkit-box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.03);
  border-radius: 20px;
}

button.secondary {
  &:hover:not(:focus):enabled {
    border-color: var(--primary-base);
    color: var(--primary-base);
  }
  &:focus:not(:active) {
    border-width: 1px;
    color: var(--primary-base);
    margin: 0;
  }
  &:active {
    box-shadow: none;
  }
}

button:focus:not(:active) {
  outline: 0;
  border: solid 2px var(--primary-light);
  margin-left: -2px;
  margin-right: -2px;
}

button:active {
  box-shadow: inset 0 2px 4px 0 rgba(24, 33, 35, 0.32);
  outline: 0;
}

button.primary:hover:enabled {
  background-color: var(--primary-dark);
}

button:disabled {
  cursor: default;
  background-color: var(--neutral-base) !important;
  color: var(--ink-light);
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommonButton.vue